// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2BJk2","productName":"Table_productName__1n0h_"};